import { isAU } from '../constants/crux';
import Report from "./reports";

const context = isAU ? '/rpp' : '/rpnz';
export const LEGACY_URI = {
    DASHBOARD: {
        RPP_PATH: `${context}/dashboard.html`,
        CRUX_PATH: '/'
    },
    PDP: {
        RPP_PATH: `${context}/property/detail.html`,
        CRUX_PATH:  /^\/property\/.*$/,
    },
    SIGNATURE_CMA: {
        RPP_PATH: `${context}/flow/cma.html`,
        CRUX_PATH: Report.SIGNATURE_REPORT_TYPES.CMA, //actual path will be formed using signature helper
    },
    SIGNATURE_RENTAL: {
        RPP_PATH: `${context}/flow/rental-cma.html`,
        CRUX_PATH: Report.SIGNATURE_REPORT_TYPES.RENTAL, //actual path will be formed using signature helper
    },
    AVM: {
        RPP_PATH: `${context}/flow/avm.html`,
        CRUX_PATH:  /^\/property\/.*$/,
    }

};
